<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
      <vs-list>
        <vs-list-header title="영어단어와 의미를 Matching 합니다" icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="ww-jumbotron-content lg:p-20 md:p-24 sm:p-16 p-8 mb-6 rounded-lg text-center" >
        <h1 class="mb-1 text-primary">{{ content.sentence}}</h1>
      </div>
      <!-- <vs-divider color="primary"> </vs-divider> -->

      <div class="vx-row ml-6">
        <div class="vx-col md:w-1/4 w-full mt-3">
            <vs-radio v-model="userAnswer" :vs-value="content.example[0]" @change="check($event)"><h4>{{ content.example[0] }}</h4></vs-radio>
        </div>
        <div class="vx-col md:w-1/4 w-full  mt-3">
            <vs-radio v-model="userAnswer" :vs-value="content.example[1]" @change="check($event)"><h4>{{ content.example[1] }}</h4></vs-radio>
        </div>
        <div class="vx-col md:w-1/4 w-full  mt-3">
            <vs-radio v-model="userAnswer" :vs-value="content.example[2]" @change="check($event)"><h4>{{ content.example[2] }}</h4></vs-radio>
        </div>
        <div class="vx-col md:w-1/4 w-full  mt-3">
            <vs-radio v-model="userAnswer" :vs-value="content.example[3]" @change="check($event)"><h4>{{ content.example[3] }}</h4></vs-radio>
        </div>
      </div>
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      userAnswer: '', 
      finished: false
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    }
  },
  methods: {
    onReload () {
      this.contentIndex = 0
      this.userAnswer = 0
      this.startAlert()
    },
    check () {

      if (this.content.answer === this.userAnswer) {
        this.correct()
        this.addResult(this.content.sentence, this.content.answer, this.userAnswer)

        if (this.contentIndex === (this.contentsLen - 1)) {
          
          setTimeout(function () {
            this.onComplete()
          }.bind(this), 1000)

        } else {
          setTimeout(function () {
            this.contentIndex = this.contentIndex + 1
            this.userAnswer = ''
          }.bind(this), 1000)
        }
      } else {
        this.inCorrect()
        this.userAnswer = ''
        this.retryCount++
        if (this.retryCount >= this.retry) {
          this.addResult(this.content.sentence, this.content.answer, this.userAnswer)
          this.retryCount = 0
          setTimeout(function () {
            this.contentIndex = this.contentIndex + 1
            this.userAnswer = ''
          }.bind(this), 1000)
        }
      }
    },
    onStart () {
    },
    startAlert () {
      this.startStudyDlg('지금까지 배운 단어를 확인합니다.')
    },
    acceptAlert () {
      this.onStart()
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)

    for (let i = 0; i < contentJson.sentence.length; i++) {
      
      const content = {
        sentence: contentJson.sentence[i],
        example: contentJson.example[i].split('|'),
        answer: contentJson.answer[i]
      } 
      this.contentList.push(content)
    }

    this.contentsLen = this.contentList.length
    this.startAlert()

    // this.contentList = [
    //   {
    //     sentence: 'you',
    //     translation: '너',
    //     sample: [
    //       '너',
    //       '미끄러지다',
    //       '준비된',
    //       '누구'
    //     ],
    //     answer: '1'
    //   },
    //   {
    //     sentence: 'slide',
    //     translation: '미끄럼을 타다',
    //     sample: [
    //       '그네를 타다',
    //       '미끄럼을 타다',
    //       '시소를 타다',
    //       '순서를 기다리다'
    //     ],
    //     answer: '2'
    //   },
    //   {
    //     sentence: 'ready',
    //     translation: '준비된',
    //     sample: [
    //       '다음의',
    //       '순서',
    //       '누구',
    //       '준비된'
    //     ],
    //     answer: '4'
    //   },
    //   {
    //     sentence: 'who',
    //     translation: '누구',
    //     sample: [
    //       '순서',
    //       '누구',
    //       '너',
    //       '준비된'
    //     ],
    //     answer: '2'
    //   },
    //   {
    //     sentence: 'next',
    //     translation: '다음의',
    //     sample: [
    //       '다음의',
    //       '준비된',
    //       '누구',
    //       '순서'
    //     ],
    //     answer: '1'
    //   },
    //   {
    //     sentence: 'turn',
    //     translation: '순서',
    //     sample: [
    //       '누구',
    //       '너',
    //       '순서',
    //       '준비된'
    //     ],
    //     answer: '3'
    //   },
    //   {
    //     sentence: '너',
    //     translation: 'you',
    //     sample: [
    //       'you',
    //       'I',
    //       'they',
    //       'we'
    //     ],
    //     answer: '1'
    //   }
    // ]
  },
  mounted () {
  }
}

</script>

<style scoped>
.ww-jumbotron-content {
    border:1px solid #7367F0;
}
.tc-ww-input {
    height: 50px;
    width: 200px;
    font-size: 30px;
    text-align: center;
    letter-spacing:10px;
} 
</style>